import * as React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  logoWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
  },
  logo: {
    display: 'flex',
    zIndex: 100,
    background: '#34414c',
    borderRadius: '50%',
    border: '3px solid #fff',
    padding: '15px',
    position: 'absolute',
    bottom: 0,
  },
}));

const WavyDialogBackground: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.logoWrapper}>
      <img src="/img/global/wavyBackground.svg" alt="" />
      <div className={classes.logo}>
        <img src="/img/global/klangio_company_logo.png" alt="" width={50} height={50} />
      </div>
    </div>
  );
};

export default WavyDialogBackground;
